import { render } from "./units-form-page.vue?vue&type=template&id=443d29f0"
import script from "./units-form-page.vue?vue&type=script&lang=js"
export * from "./units-form-page.vue?vue&type=script&lang=js"

import "./units-form-page.vue?vue&type=style&index=0&id=443d29f0&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__